import { useIntl } from "react-intl";
import SearchIcon from "src/design-system/icons/Search.svg?react";
import ArrowForward from "src/design-system/icons/ArrowForward.svg?react";
import LetterLogo from "src/design-system/icons/Rome2RioMonogram.svg?react";
import { tw } from "src/design-system/tw";
import messages from "./SmallSearchBox.messages";

type Props = {
  origin?: string;
  destination?: string;
  onClick: () => void;
  className?: string;
  textOverride?: string;
};

export function SmallSearchBox(props: Props) {
  const intl = useIntl();

  return (
    <div
      className={tw(
        `border-b border-b-border-secondary/50 bg-neutral-50 p-3`,
        props.className,
      )}
    >
      <div className="flex h-11 items-center justify-between rounded-sm bg-surface px-2 py-0 shadow-sm shadow-border-secondary active:bg-neutral-700">
        <button
          className="flex items-center"
          title={intl.formatMessage(messages.search)}
          onClick={(event) => {
            props.onClick();
            event.preventDefault();
          }}
        >
          <LetterLogo
            className="h-8 w-8"
            title={intl.formatMessage(messages.logoLabel)}
          />
        </button>
        <button
          className="flex max-w-3/4 flex-grow items-center justify-center md:max-w-none"
          title={intl.formatMessage(messages.search)}
          onClick={(event) => {
            props.onClick();
            event.preventDefault();
          }}
        >
          <div className="mx-1 flex-grow overflow-hidden">
            <div className="mx-1 flex items-center justify-center">
              {props.textOverride ? (
                <span className="pointer-events-none mx-2 block max-w-full truncate border-0 bg-transparent text-left text-base leading-none text-transport-grey-700 focus:outline-0">
                  {props.textOverride}
                </span>
              ) : (
                <>
                  <span className="pointer-events-none mx-2 block max-w-1/2 truncate border-0 bg-transparent text-left text-base leading-none text-transport-grey-700 focus:outline-0">
                    {props.origin ?? ""}
                  </span>
                  <ArrowForward
                    className="-mt-[0.5px] h-5 w-5 text-icon-primary"
                    title="arrow-forward"
                  />
                  <span className="pointer-events-none mx-2 block max-w-1/2 truncate border-0 bg-transparent text-left text-base leading-none text-transport-grey-700 focus:outline-0">
                    {props.destination ?? ""}
                  </span>
                </>
              )}
            </div>
          </div>
        </button>
        <button className="flex items-center pr-1" onClick={props.onClick}>
          <SearchIcon className="text-icon-primary" title="search" />
        </button>
      </div>
    </div>
  );
}
